// normalize the data coming from the API
export function normalizeProductData(raw) {
  return {
    // Product's Id
    productId: raw.productId || "",

    // Basic Info Section
    productName: (raw.productName || "").trim(),

    productDescription: (raw.productDescription || "").trim(),

    productImages: Array.isArray(raw.productImages)
      ? raw.productImages.map((img) => String(img).trim()).filter(Boolean)
      : [],

    productCategory: (raw.productCategory || "").trim(),

    productStatus: raw.productStatus || "draft",

    // Pricing Section
    // TODO:Finish replacing the previous name of price fields
    // Change valid number of string type to number type
    productPrice: Number.isFinite(Number(raw.productPrice ?? raw.productRetailPrice))
      ? Number(raw.productPrice ?? raw.productRetailPrice)
      : undefined,

    productDiscountedPrice: Number.isFinite(Number(raw.productDiscountedPrice ?? raw.productCompareAtPrice))
      ? Number(raw.productDiscountedPrice ?? raw.productCompareAtPrice)
      : undefined,
      
    productCostPerItem: Number.isFinite(Number(raw.productCostPerItem))
      ? Number(raw.productCostPerItem)
      : undefined,

    // Inventory Section
    trackInventory: raw.trackInventory ?? true,
    inventoryQuantity: Number(raw.inventoryQuantity) || 0,

    // SKU and barcode section
    hasSKUBarcode: Boolean(raw.productSku || raw.productBarcode),
    // Split the two for ui purpose
    hasSku: Boolean(raw.productSku),
    hasBarcode: Boolean(raw.productBarcode),
    productSku: (raw.productSku || "").trim(),
    productBarcode: (raw.productBarcode || "").trim(),

    // Variant definitions and combos
    options: Array.isArray(raw.options) ? raw.options : [],
    variants: Array.isArray(raw.variants) ? raw.variants : [],
  };
}
